import {
  Dtype,
  FieldType,
  ISimulationTableViewMetadata
} from '../types/simulation-view-table.model';

// eslint-disable-next-line import/prefer-default-export
export const SIMULATION_TABLE_COLUMN_METADATA: ISimulationTableViewMetadata = {
  DISPLAY: [
    {
      field_id: 3,
      field_name: 'tpf_product_id',
      field_display_alias: 'tpf_product_id',
      field_alias: 'tpf_product_id',
      field_value_dtype: 'INTEGER',
      field_number_format: '',
      field_format: 'NUMBER',
      field_type: FieldType.DIMENSION,
      type: 'DISPLAY',
      is_active: false,
      is_current_active: false,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: false,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: false,
      is_retailer_group_active: false,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 0,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 1,
      field_name: 'tpf_market_id',
      field_display_alias: 'tpf_market_id',
      field_alias: 'tpf_market_id',
      field_value_dtype: 'INTEGER',
      field_number_format: '',
      field_format: 'NUMBER',
      field_type: FieldType.DIMENSION,
      type: 'DISPLAY',
      is_active: false,
      is_current_active: false,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: false,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: false,
      is_retailer_group_active: false,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 0,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 2,
      field_name: 'tpf_market_name',
      field_display_alias: 'Market',
      field_alias: 'Market',
      field_value_dtype: 'STRING',
      field_number_format: '',
      field_format: 'TEXT',
      field_type: FieldType.DIMENSION,
      type: 'DISPLAY',
      is_active: true,
      is_current_active: false,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: true,
      is_retailer_group_active: false,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 1,
      is_grouped: true,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 11,
      field_name: 'tpf_ppg',
      field_display_alias: 'PPG',
      field_alias: 'PPG',
      field_value_dtype: 'STRING',
      field_number_format: '',
      field_format: 'TEXT',
      field_type: FieldType.DIMENSION,
      type: 'DISPLAY',
      is_active: true,
      is_current_active: false,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: false,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 2,
      is_grouped: true,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    }
  ],
  INPUT: [
    {
      field_id: 174,
      field_name: 'tpf_nsv',
      field_display_alias: 'NSV',
      field_alias: 'NSV',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 1,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: 'tpf_nsv_cal_new',
      perc_change_value_field_name: 'tpf_nsv_cal_change_ip_perc',
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 37,
      field_name: 'tpf_list_price',
      field_display_alias: 'List Price',
      field_alias: 'List Price',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: true,
      is_perc_active: true,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: true,
      is_gb_perc_active: true,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: false,
      is_retailer_group_active: false,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 2,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: 'tpf_list_price_cal_new',
      perc_change_value_field_name: 'tpf_list_price_cal_change_ip_perc',
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: 'tpf_base_price',
      new_formula: '',
      per_change_formula:
        '(roundDown((1+{tpf_list_price_cal_change_ip_perc}/100)*{tpf_list_price},2)/{tpf_list_price}-1)*100',
      additional_formula: ''
    },
    {
      field_id: 145,
      field_name: 'tpf_base_price',
      field_display_alias: 'Base Price',
      field_alias: 'Base Price',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: true,
      is_perc_active: true,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: true,
      is_gb_perc_active: true,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: true,
      is_retailer_group_active: false,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 3,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: 'tpf_base_price_cal_new',
      perc_change_value_field_name: 'tpf_base_price_cal_change_ip_perc',
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 127,
      field_name: 'tpf_distribution',
      field_display_alias: 'Distribution',
      field_alias: 'Distribution',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: true,
      is_perc_active: true,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: true,
      is_gb_perc_active: true,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: true,
      is_retailer_group_active: false,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 4,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: 'tpf_distribution_cal_new',
      perc_change_value_field_name: 'tpf_distribution_cal_change_ip_perc',
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 28,
      field_name: 'tpf_cogs',
      field_display_alias: 'COGs',
      field_alias: 'COGs',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: true,
      is_perc_active: true,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: true,
      is_gb_perc_active: true,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: false,
      is_retailer_group_active: false,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 5,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: 'tpf_cogs_cal_new',
      perc_change_value_field_name: 'tpf_cogs_cal_change_ip_perc',
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 208,
      field_name: 'tpf_trade_rate',
      field_display_alias: 'Trade Rate',
      field_alias: 'Trade Rate',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: true,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: true,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '',
      suffix_label: '%',
      currency_label: '',
      sort_order: 6,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: 'tpf_trade_rate_cal_new',
      perc_change_value_field_name: 'tpf_trade_rate_cal_change_ip_perc',
      additional_value_field_name: 'tpf_trade_rate_cal_additional_ip_perc',
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 210,
      field_name: 'tpf_comp_follow_flag_cal',
      field_display_alias: 'Competition Follows',
      field_alias: 'Competition Follows',
      field_value_dtype: 'BOOLEAN',
      field_number_format: '',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'INPUT',
      is_active: true,
      is_current_active: false,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: false,
      is_retailer_group_active: false,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 7,
      is_grouped: false,
      is_checkbox_field: true,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: 'tpf_comp_follow_flag_cal',
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    }
  ],
  OUTPUT: [
    {
      field_id: 136,
      field_name: 'tpf_aup_cal_new',
      field_display_alias: 'New AUP',
      field_alias: 'New AUP',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 1,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 214,
      field_name: 'tpf_retailer_profits_cal_change_abs',
      field_display_alias: 'Retailer Profit Chg',
      field_alias: 'Retailer Profit Chg',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 2,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 215,
      field_name: 'tpf_retailer_profits_cal_change_perc',
      field_display_alias: 'Retailer Profit Chg',
      field_alias: 'Retailer Profit Chg',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: true,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: false,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '',
      suffix_label: '%',
      currency_label: '',
      sort_order: 2,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 100,
      field_name: 'tpf_sales_selling_units_cal_change_abs',
      field_display_alias: 'Units Chg',
      field_alias: 'Units Chg',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '',
      suffix_label: '',
      currency_label: '',
      sort_order: 3,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 101,
      field_name: 'tpf_sales_selling_units_cal_change_perc',
      field_display_alias: 'Units Chg',
      field_alias: 'Units Chg',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: true,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '',
      suffix_label: '%',
      currency_label: '',
      sort_order: 3,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 172,
      field_name: 'tpf_nsv_cal_change_abs',
      field_display_alias: 'NSV Chg',
      field_alias: 'NSV Chg',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: false,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '$',
      suffix_label: '',
      currency_label: '',
      sort_order: 4,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    },
    {
      field_id: 173,
      field_name: 'tpf_nsv_cal_change_perc',
      field_display_alias: 'NSV Chg',
      field_alias: 'NSV Chg',
      field_value_dtype: 'FLOAT',
      field_number_format: '0,000.00',
      field_format: 'NUMBER',
      field_type: FieldType.METRIC,
      type: 'OUTPUT',
      is_active: true,
      is_current_active: true,
      is_new_active: false,
      is_perc_active: false,
      is_cf: false,
      is_perc_abs_col: true,
      is_default: true,
      is_additional_active: false,
      is_gb_new_active: false,
      is_gb_perc_active: false,
      is_gb_additional_active: false,
      is_own_view: true,
      is_retailer_view: true,
      is_retailer_group_active: true,
      prefix_label: '',
      suffix_label: '%',
      currency_label: '',
      sort_order: 4,
      is_grouped: false,
      is_checkbox_field: false,
      is_gb_checkbox_active: false,
      dtype: Dtype.FLOAT,
      metric_id: 1,
      name: '',
      new_value_field_name: null,
      perc_change_value_field_name: null,
      additional_value_field_name: null,
      checkbox_value_field_name: null,
      linked_to_field_name: null,
      new_formula: '',
      per_change_formula: '',
      additional_formula: ''
    }
  ]
};
